import React, { useState } from 'react';
import { Typography, TextField, Button, Stack, Alert, Link as MuiLink } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';
import { AuthLayout, PasswordToggle } from '../components/auth/AuthLayout';
import { tokens } from '../theme';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.login({ email, password });
      login(result.accessToken, {
        id: result.user.id,
        email: result.user.email,
        role: result.user.role as 'SUPER_ADMIN' | 'SALON_OWNER' | 'STAFF' | 'CLIENT',
      });
      navigate('/dashboard');
    } catch (err: unknown) {
      const axiosError = err as { response?: { data?: { error?: string } } };
      setError(axiosError.response?.data?.error || 'Wystąpił błąd logowania');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Zaloguj się" description="Wpisz e-mail i hasło do swojego konta Visitio.">
      <form onSubmit={handleSubmit}>
        <Stack spacing={2.5}>
          {error && (
            <Alert severity="error" role="alert">
              {error}
            </Alert>
          )}
          <TextField
            label="E-mail"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="nazwa@salon.pl"
          />
          <TextField
            label="Hasło"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            InputProps={{ endAdornment: <PasswordToggle visible={showPassword} onToggle={() => setShowPassword((v) => !v)} /> }}
          />
          <Button variant="contained" size="large" fullWidth type="submit" disabled={loading} sx={{ mt: 1 }}>
            {loading ? 'Logowanie…' : 'Zaloguj się'}
          </Button>
        </Stack>
      </form>
      <Typography variant="body2" sx={{ mt: 3, pt: 3, borderTop: `1px solid ${tokens.line}`, color: tokens.inkSoft }}>
        Nie masz jeszcze konta?{' '}
        <MuiLink component={Link} to="/register">Załóż konto</MuiLink>
      </Typography>
    </AuthLayout>
  );
};
